import { render, staticRenderFns } from "./full.vue?vue&type=template&id=3891786c&"
import script from "./full.vue?vue&type=script&lang=js&"
export * from "./full.vue?vue&type=script&lang=js&"
import style0 from "./full.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports